var _circle, _path, _path2, _circle2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGrupos(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 142.081 130.5",
    height: "1em",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.759,
    cy: 17.759,
    r: 17.759,
    fill: "#e0e0e0",
    transform: "translate(38.03)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#e0e0e0",
    d: "M64.34 47.616a19.258 19.258 0 0 1 3.645-10.417 22.908 22.908 0 0 0-4.653-.491h-15.07a22.656 22.656 0 0 0-4.627.465 19.325 19.325 0 0 1 3.671 11.193 19.271 19.271 0 0 1 9.332-2.4 20.262 20.262 0 0 1 7.702 1.65Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#e0e0e0",
    d: "M67.339 49.218a20.209 20.209 0 0 1 9.435 15.07 16.355 16.355 0 1 0-9.435-15.07Z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.363,
    cy: 16.363,
    r: 16.363,
    fill: "#fff",
    transform: "rotate(-45 96.839 -7.222)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M63.565 83.831H49.683a20.994 20.994 0 0 0-20.964 20.964v16.983l.052.258 1.163.362a95.682 95.682 0 0 0 28.486 4.6c15.406 0 24.325-4.394 24.868-4.679l1.086-.543h.1v-16.981a20.933 20.933 0 0 0-20.909-20.964Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#e0e0e0",
    d: "M90.629 66.951H76.851a20.289 20.289 0 0 1-6.229 14.059 24.917 24.917 0 0 1 17.785 23.834v5.222c13.6-.491 21.455-4.343 21.972-4.627l1.086-.569h.1V87.89a20.933 20.933 0 0 0-20.936-20.939Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M94.326 32.752a20.209 20.209 0 0 1 9.435 15.07 16.355 16.355 0 1 0-9.435-15.07Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M117.617 50.485h-13.778a20.179 20.179 0 0 1-6.23 14.036 24.917 24.917 0 0 1 17.785 23.834v5.222c13.6-.491 21.455-4.343 21.972-4.627l1.086-.543h.129V71.423a20.972 20.972 0 0 0-20.964-20.938Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M27.892 65.81a16.209 16.209 0 0 0 8.708-2.529 20.343 20.343 0 0 1 7.626-12.925c.026-.31.052-.62.052-.931A16.363 16.363 0 1 0 27.892 65.81Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M42.6 80.988a20.226 20.226 0 0 1-6.23-13.985c-.517-.026-1.008-.078-1.525-.078H20.964A21.011 21.011 0 0 0 0 87.89v16.983l.052.258 1.163.362a98.756 98.756 0 0 0 23.6 4.446v-5.118A24.917 24.917 0 0 1 42.6 80.988Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrupos);
export default __webpack_public_path__ + "static/media/grupos.b287865d8b8fc7d189a0297b7d332143.svg";
export { ForwardRef as ReactComponent };